import React from 'react'
import { Row, Col, Table } from 'react-bootstrap'

type PatientInfoProps = {
  patientName: string
  patientID: string
  patientDOB: string
  subscriberName: string
  subscriberID: string
  subscriberDOB: string
  responsibleParty: string
  rpID: string
  rpDOB: string
  carrierName: string
  groupPlan: string
  carrierPhone: string
  benefitsUsed: string
  employerName: string
  deductiblesUsed: string
}

const PatientSubscriberInfo = ({
  patientName,
  patientDOB,
  subscriberName,
  subscriberID,
  subscriberDOB,
  responsibleParty,
  rpID,
  rpDOB,
  carrierName,
  groupPlan,
  carrierPhone,
  benefitsUsed,
  employerName,
  deductiblesUsed,
}: PatientInfoProps): React.ReactElement => {
  return (
    <Row className="mb-2">
      <Col md={6}>
        <div className="bg-custom3 text-dark ps-3 p-1 rounded-top">
          <span className="fw-bold fs-5">Patient Subscriber Information</span>
        </div>
        <Table bordered striped>
          <tbody>
            <tr>
              <th>Patient Name</th>
              <td>{patientName}</td>
              <th>Patient DOB</th>
              <td colSpan={3}>{patientDOB}</td>
            </tr>
            <tr>
              <th>Subscriber Name</th>
              <td>{subscriberName}</td>
              <th>Subscriber ID</th>
              <td>{subscriberID}</td>
              <th>Subscriber DOB</th>
              <td>{subscriberDOB}</td>
            </tr>
            <tr>
              <th>Responsible Party</th>
              <td>{responsibleParty}</td>
              <th>RP ID</th>
              <td>{rpID}</td>
              <th>RP DOB</th>
              <td>{rpDOB}</td>
            </tr>
          </tbody>
        </Table>
      </Col>
      <Col md={6}>
        <div className="bg-custom3 text-dark ps-3 p-1 rounded-top">
          <span className="fw-bold fs-5">Coverage Information</span>
        </div>
        <Table bordered striped>
          <tbody>
            <tr>
              <th>Carrier Name</th>
              <td>{carrierName}</td>
              <th>Group Plan</th>
              <td>{groupPlan}</td>
            </tr>
            <tr>
              <th>Carrier Phone</th>
              <td>{carrierPhone}</td>
              <th>Benefits Used</th>
              <td>{benefitsUsed}</td>
            </tr>
            <tr>
              <th>Employer Name</th>
              <td>{employerName}</td>
              <th>Deductibles Used</th>
              <td>{deductiblesUsed}</td>
            </tr>
          </tbody>
        </Table>
      </Col>
    </Row>
  )
}

export default PatientSubscriberInfo
